export default "__VITE_ASSET__CpEhAq50__"